export default "__VITE_ASSET__CWx2LukW__"